import SchemaObject from 'schema-object'

export const Card = new SchemaObject({
  ID: Number,
  Main: Boolean,
  LastDigits: String,
  Type: String,
  TypePhoto: String,
})

export const Address = new SchemaObject({
  ID: Number,
  Address: String,
  Floor: String,
  Apartment: String,
  MainAddress: Boolean,
  PostalCode: {
    type: String,
    transform: value => {
      return value.PostalCode
    },
  },
})

export const User = new SchemaObject({
  ID: String,
  Name: String,
  LastName: String,
  Email: {
    type: String,
    transform: value => {
      return value.Email
    },
  },
  Phone: String,
  ProfilePicture: {
    type: String,
    transform: value => {
      return value.Url
    },
  },
})

export const TransactionType = new SchemaObject({
  ID: Number,
  Description: String,
})

export const TimeSlot = new SchemaObject({
  ID: Number,
  Hour: Number,
  Minute: Number,
})

export const Reserve = new SchemaObject({
  ID: Number,
  Date: Date,
  TimeSlotID: Number,
  TimeSlot: TimeSlot,
})

export const Item = new SchemaObject({
  Name: String,
  Product: Object,
  RentPrice: Number,
  Photo: Object,
})

export const Transaction = new SchemaObject({
  ID: String,
  TransactionType: TransactionType,
  Comments: String,
  GeneralInformation: String,
  Origin: String,
  Destination: String,
  ClientAddress: Address,
  Reserve: Reserve,
  Objects: [Item],
  ConfirmationDate: Date,
})

export const Rent = new SchemaObject({
  ID: Number,
  Card: Card,
  Address: Address,
  StartDate: Date,
  EndDate: Date,
  Client: User,
  Pickup: Transaction,
  Delivery: Transaction,
  Comments: String,
  Object: Item,
})

export const ApiError = new SchemaObject({
  description: {
    type: String,
  },
  detail: {
    type: String,
    invisible: true,
  },
})



// WEBPACK FOOTER //
// ./src/sections/rent/schemas.js